import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/compat'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Home.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Settings/Settings.vue')
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Account/Register.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Account/Login.vue')
    },
    {
      path: '/usermgmt',
      name: 'usermgmt',
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Account/UserManagement.vue')
    },
    {
      path: '/terms',
      name: 'terms',
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Legal/Terms.vue')
    },
    {
      path: '/conditions',
      name: 'conditions',
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Legal/Conditions.vue')
    },
    {
      path: '/protocollo',
      name: 'protocollo',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Protocollo/Dashboard.vue')
    },
    {
      path: '/timetrack',
      name: 'timetrack',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Timetrack/Dashboard.vue')
    },
    {
      path: '/timetrack/project/:id',
      name: 'project',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Timetrack/ProjectView.vue')
    },
    {
      path: '/timetrack/projects/',
      name: 'projects',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Timetrack/ProjectsView.vue')
    },
    {
      path: '/timetrack/project/tracking/:id',
      name: 'tracking',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Timetrack/TrackingView.vue')
    },
    {
      path: '/timetrack/export',
      name: 'export',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Timetrack/Export/Export.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      meta: {
        requiresAuth: true,
        requiresSuperAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/Admin/Admin.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresSuperAuth = to.matched.some(record => record.meta.requiresSuperAuth)
  if (requiresSuperAuth && (!currentUser || currentUser.uid !== process.env.VUE_APP_SUPERUSER_ID)) {
    next('/')
  }
  if (requiresAuth && (!currentUser || !currentUser?.emailVerified)) {
    next('/login')
  } else {
    next()
  }
})

export default router
